<ion-app>
  <ion-content>
    <ion-router-outlet></ion-router-outlet>
    <app-tabs />
  </ion-content>
</ion-app>
